import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ee4b8300")

_pushScopeId("data-v-ee4b8300")
const _hoisted_1 = { class: "element-content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_StaticTable = _resolveComponent("StaticTable")

  return (_openBlock(), _createBlock("div", {
    class: "base-element-table",
    style: {
      top: _ctx.elementInfo.top + 'px',
      left: _ctx.elementInfo.left + 'px',
      width: _ctx.elementInfo.width + 'px',
    }
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_StaticTable, {
        data: _ctx.elementInfo.data,
        width: _ctx.elementInfo.width,
        colWidths: _ctx.elementInfo.colWidths,
        outline: _ctx.elementInfo.outline,
        theme: _ctx.elementInfo.theme
      }, null, 8, ["data", "width", "colWidths", "outline", "theme"])
    ])
  ], 4))
})